// extracted by mini-css-extract-plugin
export var actions = "_4i-0";
export var actionsContainer = "_4i-7";
export var border = "_4i-1";
export var childFullHeight = "_4i-e";
export var collapse = "_4i-2";
export var content = "_4i-9";
export var contentChild = "_4i-d";
export var fullscreen = "_4i-b";
export var hasLeftRadius = "_4i-j";
export var headerContainer = "_4i-3";
export var headerRow = "_4i-5";
export var hidePadding = "_4i-a";
export var navCollapsedGap = "_4i-k";
export var noScrollX = "_4i-l";
export var noScrollY = "_4i-m";
export var noTopPadding = "_4i-h";
export var optOutTopPadding = "_4i-c";
export var pageMain = "_4i-i";
export var pageOuter = "_4i-f";
export var pagePadding = "_4i-8";
export var profile = "_4i-n";
export var profileContainer = "_4i-o";
export var profileImage = "_4i-p";
export var profileMain = "_4i-q";
export var profileSubtitle = "_4i-s";
export var profileTitle = "_4i-r";
export var showLeftPadding = "_4i-g";
export var tabsPortalSlot = "_4i-6";
export var tabsWrapper = "_4i-4";
export var title = "_4i-t";